// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../../graphql/api/index';

export const QuestionnaireConditionIsLessThanFragmentDoc = `
    fragment questionnaireConditionIsLessThan on QuestionnaireConditionIsLessThan {
  __typename
  question {
    id
  }
  value
}
    `;